import React from 'react';
import { TrendingUp, TrendingDown, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import './KPICard.scss';
export const KPICardSkeleton = () => (
  <div className="kpi-card kpi-card--skeleton">
    <div className="kpi-header">
      <div className="kpi-info">
        <div className="skeleton skeleton--title" />
        <div className="skeleton skeleton--value" />
      </div>
      <div className="skeleton skeleton--icon" />
    </div>
    <div className="skeleton skeleton--footer" />
  </div>
);

const KPICard = ({ 
  title, 
  value, 
  icon: Icon, 
  trend, 
  trendLabel, 
  color = 'blue',
  to,
  linkLabel
}) => {
  const isPositive = trend && trend > 0;
  const hasTrend = trend !== undefined && trend !== null;

  return (
    <div className={`kpi-card kpi-card--${color}`}>
      <div className="kpi-header">
        <div className="kpi-info">
          <p className="kpi-title">{title}</p>
          <h3 className="kpi-value">{value}</h3>
        </div>
        <div className={`kpi-icon ${color}`}>
          <Icon />
        </div>
      </div>
      
      {hasTrend && (
        <div className="kpi-trend">
          <span className={`trend-value ${isPositive ? 'positive' : 'negative'}`}>
            {isPositive ? <TrendingUp /> : <TrendingDown />}
            {Math.abs(trend)}%
          </span>
          <span className="trend-label">vs {trendLabel}</span>
        </div>
      )}

      {to && linkLabel && (
        <Link to={to} className="kpi-link">
          <span>{linkLabel}</span>
          <ArrowRight />
        </Link>
      )}
    </div>
  );
};

export default KPICard;